import React from "react";
import { withRouter } from "react-router";
import withLocation from "../../../../../hocs/withLocation";
import withUserData from "../../../../../hocs/withUserData";
import withPaymentDetails from "../../../../../hocs/withPaymentDetails";
import withAppStatus from "../../../../../hocs/withAppStatus";
import withDeviceType from "../../../../../hocs/withDeviceType";
import withBottomNavigation from "../../../../../hocs/withBottomNavigation";
import withDesktopNotificationsPanel from "../../../../../hocs/withDesktopNotificationsPanel";
import withNavbarHeight from "../../../../../hocs/withNavbarHeight";
import { getRegisterWithRedirectUrl } from "../../../../../lib/auth/authRedirectUrl";

import HeaderAbstractWeb from "./default";

import logo from "../../../../../logo";
import config from "../../../../../config";

import "../styles/squaber.scss";

@withLocation
@withRouter
@withUserData
@withPaymentDetails
@withAppStatus
@withDeviceType
@withBottomNavigation("bottomNavigationValue")
@withDesktopNotificationsPanel
@withNavbarHeight
class Header extends HeaderAbstractWeb {
  getTextLogo() {
    return (
      <img src={logo.text} className="img-fluid logo-text" alt={config.title} />
    );
  }

  getRegisterUrl() {
    const { locale } = this.props;

    return getRegisterWithRedirectUrl({ locale });
  }

  getRegisterTarget() {
    return "_self";
  }
}

export default Header;
